import { useState } from "react";

import CentralizedModalContainer from "@/appComponents/Blocks/Utils/CentralizedModalContainer/CentralizedModalContainer";
import {
  Button,
  DatePicker,
  DialogActions,
  DialogContent,
  DialogTitle,
  Flex,
  Icon,
  isNullish,
  LabelWrapper,
  Modal,
  Text
} from "@theorgchartdev/storybook";
import { generateDeltaReport } from "./PointInTimeExplorer.utils";
import { LANGUAGE_TO_DATE_LOCALE } from "@/Utils/Constants";
import { appstr } from "@coreapp/utils/appstr";
import { Globals } from "@coreapp/CoreApp/Globals";

export const DeltaReportModal = props => {
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);

  const onDateChange = setter => value => {
    setter(value);
  };

  const getDateRange = () => {
    return [dateFrom.FormatDate(23).substr(0, 6), dateTo.FormatDate(23).substr(0, 6)];
  };

  const handleDownload = async () => {
    props.onClose();
    const dateRange = getDateRange();
    await generateDeltaReport(props.chart["ID"], dateRange);
  };

  const datePickerProps = ariaLabel => {
    return {
      placeholderText: appstr("Choose date"),
      portalId: "modal-root",
      popperClassName: "oc-date-picker",
      buttonProps: {
        iconProps: {
          name: "calendar"
        },
        iconAlignEnd: true,
        ariaLabel: ariaLabel
      },
      locale:
        LANGUAGE_TO_DATE_LOCALE[Globals._stringMgr?.GetCurrentLanguage() ?? enumLanguage.english]
    };
  };

  let dateToProps = datePickerProps("Date to");
  let dateFromProps = datePickerProps("Date from");

  const validInput = (() => {
    if (isNullish(dateFrom) || isNullish(dateTo)) {
      return false;
    }

    return dateFrom < dateTo;
  })();

  return (
    <CentralizedModalContainer show>
      <Modal
        id="delta-report-modal"
        show
        minWidth={"medium"}
        maxWidth={"medium"}
        centerScreen={true}
      >
        <DialogTitle divider={true} onClose={props.onClose}>
          <span className={"ocn-explorer-icon-label"}>
            <Icon size={"medium"} name={"stopwatch"} />
            {appstr("deltareport")}
          </span>
        </DialogTitle>
        <DialogContent customContentClass={"ocn-chart-explorer-content"}>
          <Flex direction="column" gap="12px" padding={"12px 16px"}>
            <Text size={"small"} colorModifier="lightgrey">
              {appstr("Select a date range for your report")}
            </Text>
            <Flex direction="row" gap="8px">
              <LabelWrapper label={appstr("Date from")}>
                <DatePicker
                  selected={dateFrom}
                  onChange={onDateChange(setDateFrom)}
                  {...dateFromProps}
                />
              </LabelWrapper>
              <LabelWrapper label={appstr("Date to")}>
                <DatePicker selected={dateTo} onChange={onDateChange(setDateTo)} {...dateToProps} />
              </LabelWrapper>
            </Flex>
          </Flex>
        </DialogContent>
        <DialogActions divider={true}>
          <DialogActions.Tertiary
            onClick={props.onClose}
            dataTestId="chart-mode-explorer-pit-delta-cancel-btn"
          >
            {appstr("Cancel")}
          </DialogActions.Tertiary>
          <DialogActions.Primary
            disabled={!validInput}
            onClick={handleDownload}
            dataTestId="chart-mode-explorer-pit-delta-download-btn"
          >
            {appstr("Download report")}
          </DialogActions.Primary>
        </DialogActions>
      </Modal>
    </CentralizedModalContainer>
  );
};
